var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.5 12.97 2 2 4.5-4.5m-6.298 11.1c.328-.043.659.046.92.247l1.203.924c.398.305.951.305 1.348 0l1.248-.96c.234-.178.528-.257.82-.218l1.561.205c.497.066.976-.21 1.168-.674l.601-1.453c.112-.273.328-.488.6-.6l1.453-.601c.464-.192.74-.672.675-1.168l-.198-1.506a1.24 1.24 0 0 1 .247-.92l.923-1.203a1.105 1.105 0 0 0 0-1.348l-.959-1.249a1.105 1.105 0 0 1-.219-.818l.206-1.563a1.108 1.108 0 0 0-.675-1.167l-1.453-.601a1.103 1.103 0 0 1-.6-.6l-.6-1.454a1.107 1.107 0 0 0-1.169-.674l-1.562.205a1.1 1.1 0 0 1-.817-.216l-1.25-.96a1.105 1.105 0 0 0-1.347 0l-1.249.96a1.115 1.115 0 0 1-.818.219L8.196 4.17a1.108 1.108 0 0 0-1.167.675l-.6 1.453a1.117 1.117 0 0 1-.6.6l-1.453.6c-.464.192-.74.67-.675 1.168l.206 1.562a1.11 1.11 0 0 1-.219.817l-.959 1.25a1.105 1.105 0 0 0 0 1.347l.959 1.249c.179.233.258.528.219.819L3.7 17.273c-.065.497.211.976.675 1.168l1.453.6c.272.113.488.328.6.6l.6 1.454c.192.463.672.74 1.169.675l1.504-.2z",
    stroke: "#0E4E9A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.49eb969acd643133b2c76adf3ed9e598.svg";
export { ForwardRef as ReactComponent };